import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { EnablementSetPayload, EnablementSetResult } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';
import { ENABLEMENT } from './enablement.query';

// PUT sets an override (`enabled`) or clears it (`clear: true`) for a
// provider/model. Registry defaults are restored when the override is cleared.
const useSetEnablementFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (payload: EnablementSetPayload): Promise<EnablementSetResult> => {
    const raw = await request<any>(ENABLEMENT, 'PUT', payload);
    return unwrapEnvelope<EnablementSetResult>(raw);
  }, 'Failed to update enablement');
};

export const useSetEnablementMutation = () => {
  const queryClient = useQueryClient();
  const setFn = useSetEnablementFn();
  return useMutation({
    mutationFn: (payload: EnablementSetPayload) => setFn(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiKeys.enablement() });
    },
  });
};
